export enum Mutation {
    GenerateDemoAccount = "generateDemoAccount",
    ResetDemoAccount = "resetDemoAccount",
    CreateAccountCreation = "createAccountCreation",
    UpdateAccountCreation = "updateAccountCreation",
    DeleteAccountCreation = "deleteAccountCreation",
    SendAccountCreationEmail = "sendAccountCreationEmail",

    CreateUser = "createUser",
    UpdateUser = "updateUser",
    DeleteUser = "deleteUser",
    ResetUserPassword = "resetUserPassword",
    UpdateUserPreferences = "updateUserPreferences",

    CreateOrganization = "createOrganization",
    UpdateOrganization = "updateOrganization",
    DeleteOrganization = "deleteOrganization",
    ArchiveOrganization = "archiveOrganization",

    CreatePointOfSales = "createPointOfSales",
    UpdatePointOfSales = "updatePointOfSales",
    DeletePointOfSales = "deletePointOfSales",
    DuplicatePointOfSales = "duplicatePointOfSales",

    CreatePointOfSalesGroup = "createPointOfSalesGroup",
    UpdatePointOfSalesGroup = "updatePointOfSalesGroup",
    DeletePointOfSalesGroup = "deletePointOfSalesGroup",

    MatchPlatformPointOfSales = "matchPlatformPointOfSales",
    UpdateCompetition = "updateCompetition",
    UpdatePosCredential = "updatePosCredential",
    UpdatePosChannel = "updatePosChannel",
    MatchingPosExternalPosChannel = "matchingPosExternalPosChannel",
    UpdatePosVisibility = "updatePosVisibility",

    CreateSetupIntent = "createSetupIntent",
    ChangeSubscription = "changeSubscription",
    GenerateCustomerId = "generateCustomerId",
    UpdateShop = "updateShop",

    AddOrganizationExternalPos = "addOrganizationExternalPos",
    ModifyOrganizationExternalPos = "modifyOrganizationExternalPos",
    DeleteOrganizationExternalPos = "deleteOrganizationExternalPos",

    UpdateCredentials = "updateCredentials",
    SawNotification = "sawNotification",
    SawNotifications = "sawNotifications",

    SponsoredAdsCreate = "sponsoredAdsCreate",
    UpdateOneSponsoredAdSlotById = "updateOneSponsoredAdSlotById",
    UpdateOneSponsoredAdById = "updateOneSponsoredAdById",
    MarketingActionCreate = "marketingActionCreate",

    SalesForceUpdateAccount = "updateSFAccount",
    SalesForceCreateAccountChild = "createSFAccountChild",

    DisconnectCashRegister = "disconnectCashRegister",
    DeleteCashRegister = "deleteCashRegister",
    DeleteNowCashRegister = "deleteNowCashRegister",

    CancelRemoteMarketingAction = "cancelRemoteMarketingAction",

    GenerateActivityReport = "generateActivityReport",
    RefreshMaterializedView = "refreshMaterializedView",
    BillOrganizations = "billOrganizations",
    ActivityReport = "activityReport",

    MarketingActionCreateTemplate = "marketingActionCreateTemplate",
    MarketingActionRenameTemplate = "marketingActionRenameTemplate",
    MarketingActionDeleteTemplate = "marketingActionDeleteTemplate",

    CreateBulkOperation = "createBulkOperation",
}
